import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./button.module.css";
import { CircularProgress } from "Components/shared/loaders";

/**
 *
 * @param {contained | empty | outlined} variant Specify the variant of the button.
 * @param {primary | secondary | tertiary | danger | grey} color Specify the color of the button.
 * @param {Boolean} fullWidth Specify the width of the button.
 * @returns JSX.Element
 */

const Button = forwardRef(
  (
    {
      type,
      variant = "contained",
      color = "primary",
      style,
      className,
      onClick,
      label,
      children,
      disabled,
      fullWidth,
      loading = false,
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type || "button"}
        style={style}
        className={`${styles.Btn} ${styles[variant]} ${styles[color]} ${
          fullWidth ? styles.fullWidth : ""
        } ${className}`}
        onClick={(e) => (onClick ? onClick(e) : null)}
        disabled={disabled}
      >
        {loading ? (
          <CircularProgress size="35px" color="inherit" />
        ) : label ? (
          label
        ) : (
          children
        )}
      </button>
    );
  }
);
Button.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.oneOf(["contained", "empty", "outlined"]),
  color: PropTypes.oneOf(["primary", "secondary", "tertiary","danger","grey"]),
  style: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
};
export default Button;
